import { render, staticRenderFns } from "./CreateEventDialog.vue?vue&type=template&id=6b286950&scoped=true"
import script from "./CreateEventDialog.vue?vue&type=script&lang=ts"
export * from "./CreateEventDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b286950",
  null
  
)

export default component.exports